// src/components/SalesWorkspaceTour.jsx
// Onboarding tour for the Sales section (Sales Agent tab), the page users
// land on after login. Separate from ProductTour (Overview filters) with its
// own storage key.
//
// MOUNT POINT, CustomerDashboard.jsx, only while Sales Agent is visible:
//   {activeSection === "revenue-intel" && riTab === "agent" && <SalesWorkspaceTour />}
//
// Target IDs (set in CustomerDashboard.jsx / SalesWorkspace.jsx):
//   tour-sw-tabs      sub-nav (Sales Agent / Pipeline / AI Performance / Forecast)
//   tour-sw-refresh   "Refresh briefing" button
//   tour-sw-overview  Overview KPI tiles
//   tour-sw-products  Opportunities by product
//   tour-sw-filters   signal filter + sort toolbar
//   tour-sw-card      first priority card
//   tour-sw-brief     first "Open brief" button
//
// Re-trigger during dev: localStorage.removeItem("axo_sales_tour_done")

import React from "react";
import SpotlightTour from "./SpotlightTour";

const STORAGE_KEY = "axo_sales_tour_done";

const STEPS = [
  {
    targetId: null,
    title: "Welcome to your Sales Workspace",
    body: "This is where your day starts. Here's a 30-second look at how to use today's briefing.",
  },
  {
    targetId: "tour-sw-tabs",
    title: "Four views, one workspace",
    body: "Sales Agent is today's briefing. Pipeline, AI Performance and Forecast sit alongside it.",
  },
  {
    targetId: "tour-sw-refresh",
    title: "Refresh the briefing",
    body: "Regenerate today's briefing any time. You'll see a cost estimate first, and nothing is spent until you confirm.",
  },
  {
    targetId: "tour-sw-overview",
    title: "Headline numbers",
    body: "A quick read on today's pipeline before you dive into individual companies.",
  },
  {
    targetId: "tour-sw-products",
    title: "Opportunities by product",
    body: "Pick a product to narrow the priorities below to just that line.",
  },
  {
    targetId: "tour-sw-filters",
    title: "Filter and sort priorities",
    body: "Show only live deals, overdue accounts or at-risk ones, then sort by briefing order, priority score or estimated value.",
  },
  {
    targetId: "tour-sw-card",
    title: "Your priorities",
    body: "Each card shows the rank, product, AI priority score, estimated value and why it matters today.",
  },
  {
    targetId: "tour-sw-brief",
    title: "Open a brief",
    body: "Open brief to see the company summary, signals and current AI draft. From there you can jump to the full opportunity to prepare, approve and send outreach.",
  },
];

const SalesWorkspaceTour = () => (
  <SpotlightTour
    steps={STEPS}
    storageKey={STORAGE_KEY}
    counterLabel={(n, total) => `Step ${n} of ${total}`}
    waitForId="tour-sw-overview"
  />
);

export default SalesWorkspaceTour;
